import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import R from 'ramda';
import {
  initialise as initialiseAction,
  setIndex as setIndexAction,
  setTransitionStart as setTransitionStartAction,
  setTransitionEnd as setTransitionEndAction,
  setNoOfPages as setNoOfPagesAction,
} from '../modules';

const CarouselContainer = ({
  childComponent: ChildComponent,
  ...props
}) => (
  <ChildComponent
    {...props}
  />
);

const mapStateToProps = ({ carousels, content }, { carouselsStoreDataKey }) => ({
  carouselContent: R.compose(R.defaultTo({}), R.path(['carousels', carouselsStoreDataKey]))(content),
  carouselData: R.compose(R.defaultTo({}), R.prop(carouselsStoreDataKey))(carousels),
});
const mapDispatchToProps = dispatch => ({
  initialise: props => dispatch(initialiseAction(props)),
  setIndex: props => dispatch(setIndexAction(props)),
  setTransitionStart: props => dispatch(setTransitionStartAction(props)),
  setTransitionEnd: props => dispatch(setTransitionEndAction(props)),
  setNoOfPages: props => dispatch(setNoOfPagesAction(props)),
});

CarouselContainer.propTypes = {
  childComponent: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CarouselContainer);
